import React, { memo, type ComponentType } from 'react';
import type { EntryPointProps } from 'react-relay';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import ArchivesPage from '@atlassian/jira-issue-archival-archives/src/ui/index.tsx';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';

type JiraIssuesArchiveAppType = EntryPointProps<{}, {}, {}, {}>;

const JiraIssuesArchive: ComponentType<JiraIssuesArchiveAppType> = () => (
	<>
		<UFOSegment name="jira-archives">
			<JSErrorBoundary
				id="jira-issues-archives"
				packageName="jira-archives"
				teamName="kenji"
				fallback="flag"
			>
				<MarkProductStart />
				<AuthenticationCheck>
					<SubProductUpdater subProduct="software" />
					<ArchivesPage />
					<SpaStatePageReady />
				</AuthenticationCheck>
			</JSErrorBoundary>
		</UFOSegment>
	</>
);

export default memo(JiraIssuesArchive);
